import type { FC } from 'react'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'
import {
  createInternationalPhoneNumberValidationSchema,
  InternationalPhoneNumberInput,
  type CountryDialCode,
} from '@dhl/receiver-phone-input'
import { getConfig } from '~/config/index.js'

export type FormValues = {
  mobileNumber: string
}

export const initialValues: FormValues = {
  mobileNumber: '',
}

type FormProps = {
  autoFocusInput?: boolean
  disabled?: boolean
  onValidationSchemaChange?: (schema: object) => void
}

export const createValidationSchema = (t: TFunction, countryDialCode: CountryDialCode): Yup.Schema<FormValues> =>
  Yup.object({
    mobileNumber: createInternationalPhoneNumberValidationSchema(t, countryDialCode, true),
  })

export const MobileNumberForm: FC<FormProps> = ({ disabled, autoFocusInput, onValidationSchemaChange }) => {
  const { t } = useTranslation()
  const { features } = getConfig()

  const onDialCodeSelect = (countryDialCode: CountryDialCode) => {
    const validationSchema = createValidationSchema(t, countryDialCode)
    if (onValidationSchemaChange) {
      onValidationSchemaChange(validationSchema)
    }
  }

  return (
    <InternationalPhoneNumberInput
      name="mobileNumber"
      disabled={disabled}
      autoFocus={autoFocusInput ?? !disabled}
      fullWidth
      onDialCodeSelect={onDialCodeSelect}
      isMobile
      testId="mobile-number"
      countryFilter={features.profile.mobileNumber.countryFilter}
      required
    />
  )
}
